import { useToastStore } from '@/store/toast'
import { CheckCircle2, XCircle, Info, X } from 'lucide-react'

const ICONS = {
  success: <CheckCircle2 className="h-4 w-4 text-emerald-500" />,
  error: <XCircle className="h-4 w-4 text-rose-500" />,
  info: <Info className="h-4 w-4 text-brand-500" />,
}

/** Контейнер всплывающих уведомлений (фикс. снизу справа). */
export default function Toaster() {
  const toasts = useToastStore((s) => s.toasts)
  const dismiss = useToastStore((s) => s.dismiss)

  if (toasts.length === 0) return null

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2">
      {toasts.map((t) => (
        <div
          key={t.id}
          className="flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm text-gray-800 shadow-lg animate-in"
        >
          {ICONS[t.type]}
          <span>{t.message}</span>
          <button
            onClick={() => dismiss(t.id)}
            className="ml-2 text-gray-300 hover:text-gray-500"
            aria-label="Закрыть"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ))}
    </div>
  )
}
